/* eslint-disable @typescript-eslint/no-explicit-any */
import { CellFormatterComponent } from '@/ui/AutoTable/types';

export const NotNullableStringCellFormatter: CellFormatterComponent = ({ data }) => {
  return (data ?? '') as React.ReactElement;
};
